<template>
<div class="chapter">
<div class="inner_page">
<h2 id="CONTENTS">CONTENTS</h2>
<table class="autotable wd80" summary="">
<tbody><tr>
<td class="tdl">THE CAPTURE</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0005#Page_9">9</a></td>
</tr>
<tr>
<td class="tdl">NEW YEAR’S DAY</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0006#Page_23">23</a></td>
</tr>
<tr>
<td class="tdl">PEMERTON BUILDING</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0007#Page_34">34</a></td>
</tr>
<tr>
<td class="tdl">ANDERSONVILLE</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0008#Page_41">41</a></td>
</tr>
<tr>
<td class="tdl">FROM BAD TO WORSE</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0009#Page_65">65</a></td>
</tr>
<tr>
<td class="tdl">THE RAIDERS PUT DOWN</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0009#Page_75">75</a></td>
</tr>
<tr>
<td class="tdl">AN ACCOUNT OF THE HANGING</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0010#Page_81">81</a></td>
</tr>
<tr>
<td class="tdl">MOVED JUST IN TIME</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0011#Page_91">91</a></td>
</tr>
<tr>
<td class="tdl">HOSPITAL LIFE</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0012#Page_97">97</a></td>
</tr>
<tr>
<td class="tdl">REMOVED TO MILLEN</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0012#Page_109">109</a></td>
</tr>
<tr>
<td class="tdl">ESCAPE BUT NOT ESCAPE</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0014#Page_120">120</a></td>
</tr>
<tr>
<td class="tdl">RE-CAPTURED</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0015#Page_127">127</a></td>
</tr>
<tr>
<td class="tdl">A SUCCESSFUL ESCAPE</td>
<td class="tdr"><a class="pginternal" href="#/Text/Section0016#Page_136">136</a></td>
</tr>
<tr>
<td class="tdl">SAFE AND SOUND</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0017#Page_154" title="Link target outside of Sample">154</span></td>
</tr>
<tr>
<td class="tdl">THE FINIS</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0018#Page_160" title="Link target outside of Sample">160</span></td>
</tr>
<tr>
<td class="tdl">MICHAEL HOARE’S ESCAPE</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0019#Page_167" title="Link target outside of Sample">167</span></td>
</tr>
<tr>
<td class="tdl">REBEL TESTIMONY</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0020#Page_172" title="Link target outside of Sample">172</span></td>
</tr>
<tr>
<td class="tdl">SUMMARY</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0021#Page_187" title="Link target outside of Sample">187</span></td>
</tr>
<tr>
<td class="tdl">THE WAR’S DEAD</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0022#Page_188" title="Link target outside of Sample">188</span></td>
</tr>
<tr>
<td class="tdl">EX-PRISONERS AND PENSIONERS</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0023#Page_189" title="Link target outside of Sample">189</span></td>
</tr>
<tr>
<td class="tdl">LIST OF THE DEAD</td>
<td class="tdr"><span class="pginternal" href="#/Text/Section0024#Page_193" title="Link target outside of Sample">193</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?713da692